import React from 'react';
import { Image } from 'react-native-web';
import { Android, keyboard_logo } from '../../../../utils/DictionaryManagementUtils';
import { getImageByKey } from '../../../../utils/ImagesManagementUtils';
import FullPageSpecialSimulator from '../FullPageSpecialSimulator';

//= ========================================================================

const SplashScreenIntroFP = ({
  globJSON,
  simPlatform,
  imageSource,
  LabelInputText,
  TopTitle,
  slideshowRefs,
}) => (
  <FullPageSpecialSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    WithImageBackground={imageSource}
    TopTitle={TopTitle}
    LabelInputText={LabelInputText}
    numOfPointThatGetColor={2}
    slideshowRefs={slideshowRefs}
  >
    <Image
      fadeDuration={0}
      resizeMode="stretch"
      style={{
        width: simPlatform === Android ? 46 : 46,
        height: simPlatform === Android ? 46 : 46,
        marginLeft: simPlatform === Android ? 64 : 44.5,
        marginTop: simPlatform === Android ? 4 : 13,
        borderRadius: 16,
      }}
      source={getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo)}
    />
  </FullPageSpecialSimulator>
);

export default SplashScreenIntroFP;
